





























































































import Vue from 'vue'
import { Datetime } from 'vue-datetime'
import { debounce } from 'debounce'
import moment from 'moment-timezone'
export default Vue.extend({
    components: { Datetime },
    props: {
        //  A button displayed after 'display'
        button: {
            type: Object,
            default: null
        },
        //  Determines if we are allowed to edit, required if using (edit)
        canEdit: {
            type: Boolean,
            default: false
        },
        //  Applies 'center' justification to 'display' and 'value'
        center: {
            type: Boolean,
            default: false
        },
        //  The vuetify color enum that the component is styled with
        color: {
            type: String,
            default: 'primary'
        },
        //  Determines if the button to edit is disabled
        disabled: {
            type: Boolean,
            default: false
        },
        //  The name of the value being displayed
        display: {
            type: String,
            default: null
        },
        //  Determines if we display a button to edit this field inline
        edit: {
            type: Boolean,
            default: false
        },
        //  The icon the display when we are editing
        editIcon: {
            type: String,
            default: null
        },
        //  Determines if we are currently editing this field
        editing: {
            type: Boolean,
            default: false
        },
        //  Makes 'value' a clickable email link
        email: {
            type: [Boolean],
            default: false
        },
        //  The vue filter applied to the value
        filter: {
            type: String,
            default: null
        },
        //  Applies a specific font color to the 'value'
        fontColor: {
            type: String,
            default: null
        },
        //  Determines is the item occupies the entire width
        fullWidth: {
            type: [Boolean],
            default: false
        },
        //  The icon shown after 'display'
        icon: {
            type: [String],
            default: null
        },
        //  The color of the icon shown after 'display'
        iconColor: {
            type: [String],
            default: null
        },
        //  Makes 'value' a clickable http link
        link: {
            type: [Boolean],
            default: false
        },
        name: {
            type: String,
            default: null
        },
        //  Tells us if we want the words to wrap instead of truncate
        noWrap: {
            type: Boolean,
            default: false
        },
        //  Dropdown options for our dropdown/select custom field
        options: {
            type: Array,
            default: null
        },
        //  Determines if we are currently saving when editing inline
        saving: {
            type: Boolean,
            default: false
        },
        //  Makes 'value' a clickable element that emits 'valueSelected' event to parent
        select: {
            type: [Boolean],
            default: false
        },
        //  Makes 'display' and 'value' appear on the same line
        singleLine: {
            type: Boolean,
            default: false
        },
        //  Determins if the 'value' is multiple lines
        textarea: {
            type: [Boolean],
            default: false
        },
        //  The validation to use on our field
        validation: {
            type: String,
            default: null
        },
        //  The data value to be displayed
        value: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            temp: null
        }
    },
    mounted() {
        this.temp = this.value
    },
    computed: {
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        loading(): boolean {
            return this.$store.getters.loading
        },
        //  The textarea style
        textareaStyle(): object {
            return {
                border: `1px solid ${this.$colors.grey.lighten1}`,
                borderRadius: '5px',
                padding: '5px',
                width: '100%'
            }
        },
        valueFilter(): string {
            /**
             *  If the value is null, return the placeholder.
             *  If the value exists, format it based on assigned properties
             *  'link' or 'textarea'. We return a html link, multiple-line
             *  text, or the default value.
             *
             *  Else, return the placeholder
             */
            if (this.value || this.value === 0) {
                //  If this item is a link, wrap the value in a html link
                if (this.link) {
                    return `<a style="word-wrap:break-word;" @click="$emit('linkclick')">${this.value}</a>`
                    // return `<a style="word-wrap:break-word;" href="${this.value}">${this.value}</a>`
                }

                //  If the item is a textarea, wrap the value in a <div>
                if (this.textarea) {
                    return `<div>${this.value}</div>`
                }

                //  If the item is a email, wrap the value in a mailto: link
                if (this.email) {
                    return `<a style="word-wrap:break-word;" href="mailto:${this.value}">${this.value}</a>`
                }

                //  If the item has a filter set, filter the value
                if (this.filter) {
                    //  Get the correct filter string
                    const filter = this.getFilter()

                    //  If a filter does NOT exist, return the original value
                    if (!filter) return this.value

                    //  Else, use the filter to return the transformed value
                    return this.$options.filters[filter](this.value)
                }

                return this.value
            } else {
                return '<span class="grey--text font-italic">no value</span>'
            }
        }
    },
    methods: {
        onInput: debounce(function (val: string): void {
            //  Set our value
            this.temp = val

            //  Emit the value
            this.$emit('input', val)
        }, 250),
        async onEdit(hotKeyPressed: boolean = false): Promise<void> {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Validate the form
            const valid = await this.$validator.validate()

            //  If invalid, do nothing :-)
            if (!valid) return

            //  Emit our event
            this.$emit('edit', this.temp)
        },
        getFilter(): string {
            //  Create a filter map for for binding a custom name to an existing Vue filter
            const filterMap = { PHONE: 'phone' }

            //  Check if this item's filter matches a custom filter
            const customFilter = filterMap[this.filter]

            //  If a custom filter exists, return it
            if (customFilter) return customFilter

            //  Else check if the existing filter actually exists in Vue
            const filter = this.$options.filters[this.filter] || null

            //  If the filter does NOT exist, return null
            if (!filter) return null

            //  Else, return the valid attached filter string
            return this.filter
        },
        //  Helper to set date value before emitting
        setDateValue(value: string): void {
            //  Convert value to date
            const val = value ? moment(value).utc().format('MM/DD/YYYY') : null

            //  Set our value
            this.temp = val

            //  Set the value
            this.$emit('input', val)
        }
    },
    watch: {
        value(val: string): void {
            //  Anytime value updates, update our temp
            this.temp = val
        }
    }
})
